<template>
    <div class="frame-parent" id="landing-header">
        <div class="logo-parent">
            <img class="logo-icon" alt="" src="@/assets/icons/logo-title.svg" />
        </div>
        <div class="button-parent">
          <AbanButton v-if="me.loggedIn" :size="'small'" :type="'link'" :to="{name: 'user'}" :color="'primary'" class="button">
            <b>Dashboard</b>
          </AbanButton>
          <AbanButton v-else :size="'small'" :type="'link'" :to="{name: 'Login'}" :color="'primary'" class="button">
            <b>Login/Sign up</b>
          </AbanButton>
            <!-- <img class="majesticonsmenu-line" alt="" src="@/assets/icons/burger.svg" /> -->
        </div>
    </div>
</template>

<script>
import AbanButton from '../buttons/AbanButton.vue';
import { User } from '../../logic/users/user/user'

export default {
  name: 'LandingHeader',
  data() {
    return {
      me: {
        isAdmin: false
      }
    }
  },
  components: {
    AbanButton
  },
  created() {
    this.getMe()
  },
  methods: {
    getMe() {
      User.getMe()
        .then((user) => {
          this.me = user
        })
        .catch(() => { })
    }
  }
}
</script>

<style scoped>
.logo-icon {
    position: relative;
    height: 1.519rem;
    overflow: hidden;
    flex-shrink: 0;
}

.aban-prime {
    position: relative;
}

.logo-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
}

.label {
    position: relative;
    line-height: 1rem;
}

.button {
    width: 7rem;
    box-shadow: 0px 2px 5.2px rgba(41, 92, 167, 0.24);
    border-radius: 8px;
    background-color: #ebf3fe;
    height: 2.25rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    box-sizing: border-box;
    min-height: 2.25rem;
    max-height: 2.25rem;
}

.majesticonsmenu-line {
    width: 2.188rem;
    position: relative;
    height: 2.188rem;
    overflow: hidden;
    flex-shrink: 0;
}

.button-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    font-size: 0.75rem;
    color: #3483f7;
}

.frame-parent {
    background-color: var(--color-white);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 12px 12px;
    box-sizing: border-box;
    text-align: left;
    font-size: 1.321rem;
    color: var(--color-text);
    vertical-align: bottom;
}
</style>